export const BreakpointValues = {
  xxs: 320,
  xs: 360,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1441

};

export const Breakpoints = {
  xxs: `${BreakpointValues.xxs}px`,
  xs: `${BreakpointValues.xs}px`,
  sm: `${BreakpointValues.sm}px`,
  md: `${BreakpointValues.md}px`,
  lg: `${BreakpointValues.lg}px`,
  xl: `${BreakpointValues.xl}px`,
  xxl: `${BreakpointValues.xxl}px` 
};
